<template>
  <div :id="`${source}_prompt_reason`" class="px-3">
    <a-tooltip
      placement="top"
      :title="reasonText || ''"
      :overlay-style="{ maxWidth: '400px' }"
    >
      <span class="text_color cursor-pointer tag_css"> Matches your ICP </span>
    </a-tooltip>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  source: { type: String, required: true, default: "custom_table" },
  row: { type: Object, required: true },
});

const reasonText = computed(() => {
  return props.row?.reason_to_engage || null;
});
</script>
